import { render, staticRenderFns } from "./forkliftList.vue?vue&type=template&id=2979b0e6&scoped=true"
import script from "./forkliftList.vue?vue&type=script&lang=js"
export * from "./forkliftList.vue?vue&type=script&lang=js"
import style0 from "./forkliftList.vue?vue&type=style&index=0&id=2979b0e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2979b0e6",
  null
  
)

export default component.exports